module.exports = __webpack_public_path__ + "static/media/goodfrac_input.c50bc13a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/goodfrac_input.png
// module id = 2355
// module chunks = 0